import {flatten} from "./flatternArray";

export function findAllListNames(screenValues) {
    return flatten(screenValues.children, x => x.children)
        .filter(o => o.type === 'list' && o.properties && o.properties.name !== undefined)
        .map(list => {
            return list.properties.name
        });
}

export function findAdditionalListNames(screenValues) {
    return flatten(screenValues.children, x => x.children)
        .filter(o => o.type ? o.type.match(/forEach|feed/) && o.properties && o.properties.list !== undefined : false)
        .map(component => {
            return component.properties.list
        })

}

export function findForFeed(screenValues) {
    return flatten(screenValues.children, x => x.children)
        .filter(o => o.type === 'feed')
        .map(() => {
            return 'Feed Component'
        });
}